import { useRef } from 'react'
import { newIdempotencyKey } from './idempotency'

/**
 * Amal uchun barqaror `Idempotency-Key`.
 *
 * ⚠️ Kalit AMALGA bog'lanadi, so'rovga emas (`idempotency.ts`). Shuning
 * uchun u imzo o'zgarmaguncha O'ZGARMAYDI: tarmoq uzilib qayta bosilsa
 * server dublikat yaratmaydi. Imzo o'zgarsa (masalan operator summani
 * to'g'irlab qayta yuborsa) — bu boshqa amal va unga yangi kalit kerak,
 * aks holda haqiqiy ikkinchi to'lov birinchisining takrori deb jimgina
 * rad etilardi.
 *
 * @param prefix jurnalda kalit qaysi oynadan kelganini ko'rsatadi
 * @param signature amalni aniqlaydigan qiymatlar (summa, nishon va h.k.)
 */
export function useIdempotencyKey(prefix: string, signature: string): string {
  const held = useRef<{ signature: string; key: string } | null>(null)
  if (held.current === null || held.current.signature !== signature) {
    held.current = { signature, key: newIdempotencyKey(prefix) }
  }
  return held.current.key
}
